import { render, staticRenderFns } from "./DeliveryRule.vue?vue&type=template&id=2effae9d&scoped=true"
import script from "./DeliveryRule.vue?vue&type=script&lang=js"
export * from "./DeliveryRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effae9d",
  null
  
)

export default component.exports